export const mboxes = {
  myAccountDropDownMenu: "P21-200-mbox"
};
